import { render, staticRenderFns } from "./CustomConsentFormPreview.vue?vue&type=template&id=39219d6a&"
import script from "./CustomConsentFormPreview.vue?vue&type=script&lang=js&"
export * from "./CustomConsentFormPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports